<header class="wr-main-header pricing">
    <div class="wr-header__inner">
      <div class="wr-header">
  
        <div class="wr-logo">
          <a href="https://premium.gotyourbacksupport.com/" class="table-cell">
            <img class="main-logo" src="https://premium.gotyourbacksupport.com/wp-content/uploads/2022/04/header_logo.svg"
                 alt="">
          </a>
        </div>
  
        <div class="main-nav">
          <div class="wr-navigation">
            <div class="wr-main-menu">
              <div class="wr-header__contact--mobile">
                <a href="tel: +1 888 378 5718" class="wr-header__contact--phone">
                  <img
                    src="https://premium.gotyourbacksupport.com/wp-content/uploads/2022/04/live-support-agent-headset-1.png"
                    alt="">
                  <span>+1 888 378 5718</span>
                </a>
                <a href="" class="button-green scroll-down">
                  <i class="icon ion-arrow-right-c"></i>
                  <span></span>
                </a>
              </div>
            </div>
            <div class="wr-header__contact">
              <a href="tel: +1 888 378 5718" class="wr-header__contact--phone">
                <img
                  src="https://premium.gotyourbacksupport.com/wp-content/uploads/2022/04/live-support-agent-headset-1.png"
                  alt="">
                <span>+1 888 378 5718</span>
              </a>
            </div>
            <div class="wr-nav-menu-icon"><i></i></div>
          </div>
        </div>
      </div>
    </div>
</header>